import React, {useState, useEffect} from "react";
import {setMarkerNow, setMarkerActivity} from "../redux/actions/actions";
import {connect} from "react-redux";
import {isTablet} from "../utils/screenSize";
import {trackTapMarker} from "../utils/gestureTracker";

const Marker = (props) => {
    const [initialWidth, setInitialWidth] = useState(0);

    useEffect(() => {
        const updateInitialWidth = () => {
            const width = props.isPortrait
                ? (props.markerWidth * props.viewSize[1] * (isTablet() ? 1.2 : 0.85)) / 100
                : (props.markerWidth * props.viewSize[1]) / 100;
            setInitialWidth(width);
        };

        updateInitialWidth();
        window.addEventListener("resize", updateInitialWidth);
        return () => window.removeEventListener("resize", updateInitialWidth);
    }, [props.markerWidth, props.viewSize]);

    let style = {};
    let rotation = 0;
    // const width = props.isPortrait ? `${props.markerWidth * props.viewSize[1] / 100}px`
    //     : (props.isLandscape ? `${props.markerWidth * props.viewSize[0] / 100}px`
    //         : `${props.markerWidth * props.viewSize[1] / 100}px`);
    const width = initialWidth ? `${initialWidth}px` : 'auto';
    let markerStyle = {width: "100%"};
    const buttonBoxHeight = props.viewSize[1] * (props.isPortrait ? (isTablet() ? 0.85 : 0.6) : 1);
    const markerObj = props.data;
    const isDesktop = !props.isPortrait && !props.isLandscape;
    const markerTranslate = markerObj?.button ? "None" : isDesktop ? `translate(-50%, calc(-50% + 3px))` : (isTablet() ? `translate(-50%, calc(-50% + 2px))` : `translate(-50%, calc(-50% + 1px))`);
    if (props.action === "image marker") {
        rotation = props.data.cam_rotation;
        style = {
            position: "absolute",
            width: markerObj.button ? "auto" : width,
            top: props.data.cam_pos_y + "%",
            left: props.data.cam_pos_x + "%",
            zIndex: "123",
            transform: markerTranslate,
            transformOrigin: `top left`,
        };
        markerStyle = {
            ...markerStyle,
            transform: `rotate(${rotation}deg)`,
        };
    }
    if (props.action === "video marker") {
        style = {
            position: "absolute",
            width: props.data.cam_width + "px",
            top: props.data.pos_y + "%",
            left: props.data.pos_x + "%",
            zIndex: "123",
        };
        rotation = 0;
        markerStyle = {
            ...markerStyle,
            transform: `rotate(${rotation}deg)`,
        };
    }
    if (props.action === "panelum marker") {
        style = {
            position: "absolute",
            width: width,
            top: props.data.pos_y + "%",
            left: props.data.pos_x + "%",
            zIndex: "123",
            transform: markerTranslate,
            transformOrigin: `top left`,
        };
        rotation = 0;
        markerStyle = {
            ...markerStyle,
            transform: `rotate(${rotation}deg)`,
        };
    }
    if (props.active && props.planRef.current) {
        const planBlock = props.planRef.current.getBoundingClientRect();
        const x =
            ((parseFloat(style.top) * planBlock.height) / 100 + planBlock.top) /
            window.innerHeight;
        const y =
            ((parseFloat(style.left) * planBlock.width) / 100 + planBlock.left) /
            window.innerWidth;
        if (props.isPortrait) {
            // props.setSliderTop(x <= 0.5 ? 55 : 10);
            props.setSliderTop(25);
        } else if (props.isLandscape) {
            props.setSliderLeft(y <= 0.5 ? 50 : 0);
        }
    }

    const handleMarkerClick = (e) => {
        const mx = props.action === "image marker" ? props.data.cam_pos_x : props.data.pos_x;
        const my = props.action === "image marker" ? props.data.cam_pos_y : props.data.pos_y;
        trackTapMarker(mx, my);
        props.setSlidePlay(false);
        if (props.action === "video marker") {
            props.setMedia(props.data.video);
            props.setMediaType("video");
        }
        if (props.action === "panelum marker") {
            props.setMedia(props.data.img);
            props.setMediaType("panorama");
            props.setYaw(props.data.yaw);
            props.setPitch(props.data.pitch);
            props.setHfov(props.data.hfov);
            props.setIsMarkerClicked(true);
        }
        if (props.action === "image marker") {
            props.setMedia(props.data.img);
            props.setMediaType("image");
            props.setIsMarkerClicked(true);
        }
        if (
            props.active &&
            (props.isPortrait || props.isLandscape) &&
            props.openImage
        ) {
            props.setOpenImage(false);
        } else {
            props.setIndexMarker(props.index);
            props.setOpenImage(true);
        }
    };

    return (
        <div
            className={"markerWrap not-draggable"}
            style={style}
            onClick={handleMarkerClick}
            onTouchEnd={(e) => {
                e.preventDefault();
                handleMarkerClick(e);
            }}
            onMouseEnter={() => {
                if (props.isPortrait || props.isLandscape) {
                    return;
                }
                if (props.action === "image marker" && !markerObj.button) {
                    props.setSlidePlay(false);
                    props.setMedia(props.data.img);
                    props.setIndexMarker(props.index);
                    props.setMediaType("image");
                    if (
                        props.active &&
                        document.getElementsByClassName("kenburns_image")[props.index]
                    ) {
                        props.setKenBurnsZoom((prev) => ({
                            ...prev,
                            from: document.getElementsByClassName("kenburns_image")[
                                props.index
                                ].style.transform,
                        }));
                    }
                    if (
                        !props.active &&
                        document.getElementsByClassName("kenburns_image")[props.index]
                    ) {
                        props.setKenBurnsZoom({
                            from: {
                                transform: "scale(1)",
                            },
                            to: {
                                transform: "scale(1)",
                            },
                            config: {
                                duration: 4200,
                            },
                        });
                    }
                }
            }}
        >
            {(props.action === "image marker" || props.action === "panelum marker") &&
            markerObj?.button ? (
                <button
                    style={{
                        background: markerObj.button_bg,
                        color: markerObj.button_color_text,
                        transform: `scale(${markerObj.button_scale})`,
                        width: `${(markerObj.button_width * buttonBoxHeight) / 100}px`,
                        height: `${(markerObj.button_height * buttonBoxHeight) / 100}px`,
                        borderRadius: `${(markerObj.button_radius * buttonBoxHeight) / 100}px`,
                        fontSize: `${(markerObj.button_font_size * buttonBoxHeight) / 100}px`,
                        fontFamily: markerObj.button_font_family,
                        fontWeight: markerObj.button_font_weight,
                        fontStyle: markerObj.button_font_style,
                    }}
                >
                    {markerObj.button_label}
                </button>
            ) : (
                <img style={markerStyle} src={props.src} className="marker" alt=""/>
            )}
        </div>
    );
};

const putState = (state) => {
    return {
        ifl_state: state.ifl_state,
        now_level: state.now_level,
        now_image: state.now_image,
    };
};

const putActions = (dispatch) => {
    return {
        changeStep: (step) => dispatch(changeStep(step)),
        initImage: (image) => dispatch(initImage(image)),
        setMarkerActivity: (bool) => dispatch(setMarkerActivity(bool)),
        setMarkerNow: (index) => dispatch(setMarkerNow(index)),
    };
};

export default connect(putState, putActions)(Marker);